import http from 'hub-http/clients/apiClient';
export function bulkRestore(ids) {
  return http.put('cosemail/v1/emails/restore-deleted/bulk', {
    query: {
      id: ids,
      failIfNotAllSucceed: true
    }
  });
}